<div class="column-container section-container">
  <div class="section-title">{{ 'Integration' | translate }}</div>

  <div class="integration-card settings-card">
    <div class="integration-row">
      <app-pencil-icon class="integration-icon" name="edlink" type="svg-icon"></app-pencil-icon>

      <ng-container *ngIf="edlinkIntegration$ | async as edlinkIntegration; else notConfigured">
        <div class="text-block">
          <div class="name">{{ 'Edlink' | translate }}</div>
          <div class="status-line">
            <span class="status-dot"></span>
            <span class="status-label">{{ 'Active' | translate }}</span>
            <span class="separator">·</span>
            <span class="sync-summary">
              {{
                edlinkIntegration.syncedUserCount
                  ? (
                      '{{userCount}}
              user(s) synced across {{ siteCount }} site(s)' | translate : { userCount:
              edlinkIntegration.syncedUserCount | number, siteCount:
              edlinkIntegration.syncedSiteCount | number } ) : ('0 user synced' | translate) }}
            </span>
          </div>
        </div>

        <app-pencil-button
          theme="primary"
          [label]="'Sync' | translate"
          (clickEvent)="syncEdlink()"
          buttonType="button"
          icon="sync"
          [iconConfig]="{ type: 'material-icon' }"
          [showSpinner]="isSyncing$ | async"
          [disabled]="(isSyncing$ | async) || !!edlinkIntegration.syncedAt"
        >
        </app-pencil-button>
      </ng-container>

      <ng-template #notConfigured>
        <div class="text-block">
          <div class="name">{{ 'Edlink' | translate }}</div>
          <div class="connect-description">
            {{ 'Connect your LMS or SIS to import roster data through Edlink.' | translate }}
            <a
              href="https://helpdesk.pencilspaces.com/en/articles/16197884-how-do-i-integrate-with-edlink"
              target="_blank"
              class="learn-more-link"
              >{{ 'Learn more' | translate }}</a
            >
          </div>
        </div>

        <app-pencil-button
          theme="primary"
          [label]="'Connect' | translate"
          (clickEvent)="openContactSupportPrompt()"
          buttonType="button"
          icon="swap_horiz"
          [iconConfig]="{ type: 'material-icon' }"
        >
        </app-pencil-button>
      </ng-template>
    </div>
  </div>
</div>
